import { axiosClient } from './AxiosClient'

function listCompany(callback, errorCallback){
    let url = "/company/admin/list_all_by_building";

    axiosClient.get(url, {
        params: {
            building_id: localStorage.getItem('building_id')
        }
    })
    .then((response)=>{
        callback(response.data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function listSelectByBuilding(buildingId, callback, errorCallback){
    const url = "/company/admin/list_select_by_building"
    const query = {
        building_id: buildingId
    }
    axiosClient.get(url, {
        params: query
    })
    .then((response) => {
        callback(response.data)
    })
    .catch((error) => {
        errorCallback(error)
    })
}

function addCompany(companyName, companyNameEn, acronym, branch, branchCode, location, officePhone, type , floorId, isInformation, callback, errorCallback){
    let url = "/company/admin/create";

    var bodyForm = new FormData()
    bodyForm.append("company_name", companyName)
    bodyForm.append("company_name_en", companyNameEn)
    bodyForm.append("acronym", acronym)
    bodyForm.append("branch", branch)
    bodyForm.append("branch_code", branchCode)
    bodyForm.append("location", location)
    bodyForm.append("office_phone", officePhone)
    bodyForm.append("type", type)
    bodyForm.append("building_id", localStorage.getItem('building_id'))
    if(floorId){
        bodyForm.append("floor_id", floorId)
    }
    bodyForm.append("is_information", isInformation)

    axiosClient.post(url, bodyForm)
    .then((response)=>{
        callback(response.data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function removeCompany(companyId, callback, errorCallback){
    let url = "/company/admin/delete";

    var bodyForm = new FormData()
    bodyForm.append("company_id", companyId)

    axiosClient.post(url, bodyForm)
    .then((response)=>{
        callback(response.data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function viewCompany(companyId, callback, errorCallback){
    let url = "/company/admin/view";

    var bodyForm = new FormData()
    bodyForm.append("company_id", companyId)

    axiosClient.post(url, bodyForm)
    .then((response)=>{
        let data = response.data
        callback(data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function updateCompany(companyId, companyName, companyNameEn, acronym, branch, branchCode, location, officePhone, type , floorId, isInformation, callback, errorCallback){
    let url = "/company/admin/edit";

    var bodyForm = new FormData()
    bodyForm.append("company_id", companyId)
    bodyForm.append("company_name", companyName)
    bodyForm.append("company_name_en", companyNameEn)
    bodyForm.append("acronym", acronym)
    bodyForm.append("branch", branch)
    bodyForm.append("branch_code", branchCode)
    bodyForm.append("location", location)
    bodyForm.append("office_phone", officePhone)
    bodyForm.append("type", type)
    if(floorId){
        bodyForm.append("floor_id", floorId)
    }
    bodyForm.append("is_information", isInformation)

    axiosClient.post(url, bodyForm)
    .then((response)=>{
        callback()
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

export { listCompany, listSelectByBuilding, addCompany, removeCompany, viewCompany, updateCompany }